import { AUTH_TOKEN, onLogout } from '@/vue-apollo.js'
import { make } from 'vuex-pathify'
import jwt from 'jsonwebtoken'
import { apolloProvider } from '@/main'
import router, { routes } from '@/router'

const state = () => ({
  data: {
    access_rights: [],
    first_name: null,
    last_name: null,
    email: null
  }
})

const actions = {
  isValidToken({ commit }) {
    const token = localStorage.getItem(AUTH_TOKEN)
    const user = jwt.decode(token)
    if (user) {
      commit('SET_DATA', user)
    }
    return Boolean(user)
  },

  login({ dispatch }, token) {
    localStorage.setItem(AUTH_TOKEN, token)
    const user = jwt.decode(token)
    const accessRights = user.access_rights
    if (!accessRights) {
      return dispatch('logout')
    }

    if (accessRights.includes('REGISTER_CROWDED_TRAIN')) {
      return router.push('/')
    }

    const firstAccessRight = accessRights[0]
    return router.push(routes.find(x => x.name === firstAccessRight).path)
  },

  logout() {
    onLogout(apolloProvider.clients.defaultClient)
    return router.push('/login')
  },

  setToken({ commit }, token) {
    localStorage.setItem(AUTH_TOKEN, token)
    const user = jwt.decode(token)
    if (user) {
      commit('SET_DATA', user)
    }
  }
}

const getters = {
  fullName: state => `${state.data.first_name} ${state.data.last_name}`,

  hasAccess: state => accesses => {
    const accessRights = state.data.access_rights
    return accessRights.some(access => accesses.includes(access))
  },

  accessRights: state => state.data.access_rights || [],

  isSj: state => state.data.email.toLowerCase().includes('@sj.se')
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
